// modules
import { handleActions } from 'redux-actions'

// actions
import {
  setProviderPortalList,
  setProviderPortalItem,
  setProviderPortalModalClinicians,
  resetProviderPortal
} from 'src/store/modules/admin/providerPortal'
import { setProviderPortalLoading } from './actionCreators'

const initialState = {
  providerPortalList: [],
  providerPortalItem: {},
  providerPortalModalClinicians: [],
  providerPortalLoading: false
}

export default handleActions(
  {
    [setProviderPortalLoading](state) {
      return {
        ...state,
        providerPortalLoading: true
      }
    },
    [setProviderPortalList](state, { payload: providerPortalList }) {
      return {
        ...state,
        providerPortalList
      }
    },

    [setProviderPortalItem](state, { payload: providerPortalItem }) {
      return {
        ...state,
        providerPortalItem
      }
    },

    [setProviderPortalModalClinicians](
      state,
      { payload: providerPortalModalClinicians }
    ) {
      return {
        ...state,
        providerPortalLoading: false,
        providerPortalModalClinicians
      }
    },

    [resetProviderPortal]() {
      return initialState
    }
  },
  initialState
)
